<div class="trinka_cloud_wrap">
    <div id="particles-js"></div>
    <div class="cloud_top_banners">
        <div class="container">
            <div class="row">
                <div class="col-lg-8">
                    <div class="trinka_cloud_banner_text">
                        <h1>提高写作质量和让<br />编辑工作更顺畅</h1>
                        <p>使您的团队能够更一致地写作、更快地发布，并且提升客户体验。在不牺牲写作质量、一致性、品牌形象和写作风格的的前提下减少写作时间和降低成本。</p>
                        <button style="margin: 0; padding: 0;" (click)="sectionValue('Enterprise Form')" id="salesContactButtons" data-toggle="modal"
                            data-target="#EnterPriseContactPopup" class="plansButtons" type="submit">获取报价</button>
                    </div>
                </div>
                <div class="col-lg-4">
                    <div class="trinka_cloud_banner_img">
                        <img src="assets/images/language-services-publishing-and-media.png" alt="Trinka enterprise" class="img-fluid">
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="most_suited_for_section">
        <div class="container">
            <div class="row">
                <div class="col-lg-12">
                    <div class="most_united_heading">
                        <h2>
                            <span></span>以行业为中心的解决方案</h2>
                    </div>
                </div>
                <div class="col-lg-12">
                    <div class="most_suited_point">
                        <ul>
                            <li>编辑和校对公司</li>
                            <li>媒体和出版社</li>
                            <li>博主和博客网站</li>
                            <li>翻译服务公司</li>
                            <li>预出版工作室</li>
                            <li>营销机构</li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="brandLogo_sections">
        <div class="container">
            <div class="row">
                <div class="col-sm-2">
                    <h2>深受全球领导者信赖</h2>
                </div>
                <div class="col-sm-10">
                    <div class="cover_wrapper">
                        <div id="client-logos-enterprise" class="owl-carousel">
                            <div class="item">
                                <div class="client-inners">
                                    <img src="assets/images/client_logos/alternet.png" alt="">
                                </div>
                            </div>

                            <div class="item">
                                <div class="client-inners">
                                    <img src="assets/images/client_logos/HarperCollinsPublishers.png" alt="">
                                </div>
                            </div>
                            <div class="item">
                                <div class="client-inners">
                                    <img src="assets/images/client_logos/scholastic.png" alt="">
                                </div>
                            </div>
                            <!-- <div class="item">
                                <div class="client-inners">
                                    <img src="assets/images/client_logos/RightlyWritten.png" alt="">
                                </div>
                            </div> -->
                            <div class="item">
                                <div class="client-inners">
                                    <img src="assets/images/client_logos/sanchini.png" alt="">
                                </div>
                            </div>
                            <div class="item">
                                <div class="client-inners">
                                    <img src="assets/images/client_logos/technica.png" alt="">
                                </div>
                            </div>
                            <div class="item">
                                <div class="client-inners">
                                    <img src="assets/images/client_logos/CapstoneWriting.png" alt="">
                                </div>
                            </div>
                            <div class="item">
                                <div class="client-inners">
                                    <img src="assets/images/client_logos/evolution_editing.png" alt="">
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    </div>
    <div class="wayToIntegrateTrinka">
        <div class="container">
            <div class="row">
                <div class="col-sm-12">
                    <div class="integreate_heading_section">
                        <h2>帮助您的团队更好写作的企业功能</h2>
                        <div class="HeadingSubLine"></div>
                        <p>Trinka可以帮助您的团队高效创建关键文档，同时确保写作质量并符合科学写作习惯。</p>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-lg-12">
                    <ul>
                        <li>
                            <div class="features_cards">
                                <div class="features_cards_icon">
                                    <img src="assets/images/BulkEditingOperations.svg" alt="" srcset="">
                                </div>
                                <div class="features_cards_desc">
                                    <h3>批量编辑操作</h3>
                                    <p>上传您的微软Word文档，Trinka能够在几分钟内对其进行编辑。您只需下载编辑过的文件，然后查看所有更改即可完成工作。
                                    </p>
                                </div>
                            </div>
                        </li>
                        <li>
                            <div class="features_cards">
                                <div class="features_cards_icon">
                                    <img src="assets/images/MedicalSpellCheckicon.svg" alt="" srcset="">
                                </div>
                                <div class="features_cards_desc">
                                    <h3>上下文拼写检查和字典</h3>
                                    <p>Trinka的内置拼写检查器清楚知道“from”和“form”之间的区别，也知道数百万个技术词汇。每个团队成员都可以创建个人词典或使用同一个词典来轻松保持您相关品牌的所有通信的一致性。</p>
                                </div>
                            </div>
                        </li>
                        <li>
                            <div class="features_cards">
                                <div class="features_cards_icon">
                                    <img src="assets/images/WordCountreductions.png" alt="" srcset="">
                                </div>
                                <div class="features_cards_desc">
                                    <h3>字数缩减</h3>
                                    <p>Trinka可帮助您简明扼要地表达观点，让您的信息产生正确的影响力。您的团队在写作的同时也在学习！</p>
                                </div>
                            </div>

                        </li>
                        <li>
                            <div class="features_cards">
                                <div class="features_cards_icon">
                                    <img src="assets/images/Suggestionsthatmatchyourtone.png" alt="" srcset="">
                                </div>
                                <div class="features_cards_desc">
                                    <h3>符合您写作语气的建议</h3>
                                    <p>无论您写休闲文章还是正式文档，Trinka的人工智能都会提供正确的建议。对于研究性质的文档，您甚至可以设置研究类型，包括原创研究、评论文章和案例报告。
                                    </p>
                                </div>
                            </div>
                        </li>

                        <li>
                            <div class="features_cards">
                                <div class="features_cards_icon">
                                    <img src="assets/images/EasyUserManagement.svg" alt="" srcset="">
                                </div>
                                <div class="features_cards_desc">
                                    <h3>简易的用户管理</h3>
                                    <p>您的团队账户允许您轻松添加或删除成员。实时管理信用和使用限制。通过Trinka的细化控制，访问管理变得简单而安全--无论是您的员工还是外包的接案人员。</p>
                                </div>
                            </div>
                        </li>
                        <li>
                            <div class="features_cards">
                                <div class="features_cards_icon">
                                    <img src="assets/images/ppc_icon.png" width="40" height="40" alt="" srcset="">
                                </div>
                                <div class="features_cards_desc">
                                    <h3>抄袭检测</h3>
                                    <p>先进的文本相似性检测算法，高质量的抄袭检查， iThenticate技术支持，最大的付费出版物数据库。
                                    </p>
                                </div>
                            </div>
                        </li>
                        <li>
                            <div class="features_cards">
                                <div class="features_cards_icon">
                                    <img src="assets/images/ComprehensiveAnalytics.svg" alt="" srcset="">
                                </div>
                                <div class="features_cards_desc">
                                    <h3>综合分析</h3>
                                    <p>了解您的团队如何使用Trinka，或通过丰富的分析深入了解每个用户的活动，以制定有效的决策。</p>
                                </div>
                            </div>
                        </li>

                        <li>
                            <div class="features_cards">
                                <div class="features_cards_icon">
                                    <img src="assets/images/DedicatedSupport.svg" alt="" srcset="">
                                </div>
                                <div class="features_cards_desc">
                                    <h3>专门的支持</h3>
                                    <p>指定一名专门的成经验丰富的经理来帮助您的团队充分利用Trinka，包括详细的产品熟悉过程、帮助文档和视频演练。</p>
                                </div>
                            </div>
                        </li>
                    </ul>
                    <span class="bottom_diviedLine"></span>
                    <span class="bottom_diviedLine1"></span>

                </div>
            </div>

        </div>
    </div>
</div>

<div class="advanceGrammerSpellCheck_section backgrondSecitons_outer accomplishSections sec2">
    <div class="container">
        <div class="row">
            <div class="col-xl-4">
                <div class="spellcheck_heading EnhancementsHeadingSection">
                    <h2>为所有用例提供帮助</h2>
                    <div class="HeadingSubLine"></div>
                    <p>借助针对特定行业和角色量身定制的用例，发现Trinka的强大功能。</p>
                </div>
            </div>
            <div class="col-xl-8">
                <div class="all_usecases">
                    <div class="row">
                        <div class="col-md-6">
                            <div class="all_usecases_item">
                                <h4>内容编辑的强大帮助</h4>
                                <p>Trinka纠正语法和高级机械性问题，让您的编辑专家可以专注于语义和交付，这样可以提高输出质量并有助于简化工作流程。</p>
                                <ul>
                                    <li>改进项目的周转时间</li>
                                    <li>提高编辑质量</li>
                                    <li>缩短发布时间</li>
                                </ul>
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="all_usecases_item">
                                <h4>对于营销团队</h4>
                                <p>借助Trinka的精确建议，您的团队能够创建更好的客户电子邮件、营销资料、通讯、报告，以及宣传等。</p>
                                <ul>
                                    <li>避免客户沟通中出现令人尴尬的错误</li>
                                    <li>轻松保持品牌和重点</li>
                                    <li>缩短内容的交付时间</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-6">
                            <div class="all_usecases_item">
                                <h4>关于编辑质量评估</h4>
                                <p>Trinka的写作评估人工智能可以为您提供有用的见解，包括可自定义的写作分数和按类别划分的写作错误解析。</p>
                                <ul>
                                    <li>关于写作质量的定量剖析</li>
                                    <li>协助编辑招聘</li>
                                    <li>带有解释和提示的学习机会</li>
                                </ul>
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="all_usecases_item">
                                <h4>翻译后自动语法检查</h4>
                                <p>翻译团队可以使用Trinka通过精确的语法更正来改进他们的英语翻译，并获得高质量的分析。</p>
                                <ul>
                                    <li>上下文拼写检查</li>
                                    <li>技术用语和句子结构改进</li>
                                    <li>用于高通量工作流程的自动化文件编辑</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>


        </div>
    </div>
</div>

<div class="softWare_workFlow cloud_key_features">
    <div class="container">
        <div class="row">
            <div class="col-md-12">
                <div class="brandlogo_heading key_features_heading">
                    <h2>与您的专属软件和工作流程集成</h2>
                </div>
                <div class="HeadingSubLine"></div>
                <p>Trinka的简单集成让您的团队在现有的软件中享受所有的好处，使有效的写作变得富有成效和无缝。</p>
            </div>
        </div>
        <div class="row">
            <div class="col-md-4">
                <div class="features_cards">

                    <h3>JavaScript</h3>

                    <p>只需将一个很小的JavaScript(JS)代码片段插入到您的浏览器或任何应用程序，即可为所有团队成员启用Trinka功能。</p>
                </div>
            </div>
            <div class="col-md-4">
                <div class="features_cards">
                    <h3>应用程序接口（API）</h3>
                    <p>Trinka强大的应用程序接口（API）让它可以直接集成到您现有的应用程序中。Trinka采用简单的应用程序接口架构，集成很容易。</p>
                </div>
            </div>
            <div class="col-md-4">
                <div class="features_cards">

                    <h3>内部部署</h3>
                    <p>Trinka将托管在您的企业基础架构（本地或云服务器）上，确保您团队有效写作的同时保持最大程度的机密性。</p>

                </div>
            </div>
            <div class="col-md-4">
                <div class="features_cards">

                    <h3>云编辑器</h3>
                    <p>通过安全的基于Web的应用程序，随时随地发挥Trinka的全部潜力。</p>

                </div>
            </div>
            <div class="col-md-4">
                <div class="features_cards">

                    <h3>微软Word插件</h3>
                    <p>通过在微软Word中提供写作建议来提高团队的工作效率。</p>
                </div>
            </div>
            <div class="col-md-4">
                <div class="features_cards">
                    <h3>浏览器插件</h3>
                    <p>插件适用于所有受欢迎的浏览器，为您在任何网站提供实时的写作帮助。</p>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="most_suited_for_section pricing_works">
    <div class="container">
        <div class="row">
            <div class="col-lg-12">
                <div class="brandlogo_heading">
                    <h2>适合您的个性化定价</h2>
                </div>
                <p>Trinka提供基于用户数量或使用情况的灵活定价，以满足用户的独特需求。</p>
                <p>您可以实时切换用户并应用使用限制，而无需额外费用。<br />
                    我们将与您合作，通过采购订单或者发票轻松定制合同和单一付款选项。</p>
            </div>

            <div class="col-lg-12">
                <div class="try_trinka_Buttons">
                    <!-- <a href="https://cloud.trinka.ai/signup?_rg=CN" target="_blank">Get a Quote</a> -->

                    <button style="margin: 0; padding: 0;" (click)="sectionValue('Enterprise Form')" id="salesContactButtons" data-toggle="modal"
                        data-target="#EnterPriseContactPopup" class="plansButtons" type="submit">获取报价</button>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="writeToolboxs_section">
    <div class="writeToolbox_inner_sections">
        <div class="container">
            <div class="row">
                <div class="col-lg-7">
                    <div class="toolbox_text_content">
                        <h3>安全、可靠、值得信赖</h3>
                        <p>Trinka将数据安全和隐私放在首位。您的所有数据都经过高度加密并安全存储，没有其他人能够访问您的数据。我们提供独有的方案，一旦送给您写作建议，我们就会完全删除保存的数据。
                        </p>
                    </div>
                </div>
                <div class="col-lg-5">
                    <div class="toolbox_img_content">
                        <img src="assets/images/safe-secure.png" alt="" class="img-fluid">
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="writeToolbox_inner_sections sections_height_set publicationCheckSections" style="background-image: url('../../../assets/images/toolbox_backgrond_browser_plugin_r.png');">
        <div class="container">
            <div class="row">
                <div class="col-lg-5">
                    <div class="toolbox_img_content">
                        <img src="assets/images/about-ai.png" alt="" class="img-fluid">
                    </div>
                </div>
                <div class="col-lg-7">
                    <div class="toolbox_text_content">
                        <h3>关于人工智能</h3>
                        <p>Trinka使用最新的机器学习(ML)和自然语言处理(NLP)技术来识别语法错误并提出语言改进建议。Trinka是数百万篇优秀论文和文章的训练成果。它涵盖了1300多个学科领域，包括医学、生命科学、生物学、物理科学、工程、人文、商业和艺术，能为您提供最相关的建议。</p>
                        <p>Trinka由语言学家、医学编辑、数据科学家和工程师组成的团队开发而成，他们深切希望通过无障碍沟通创造未来。</p>

                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="enterprise_contactUs">
    <p>使用Trinka改变您的业务沟通方式</p>
    <button (click)="sectionValue('Enterprise Form')" id="salesContactButtons" data-toggle="modal" data-target="#EnterPriseContactPopup"
        class="plansButtons" type="submit">获取报价</button>
</div>



<div class="modal custom_modal_popup enterprisePopup" id="EnterPriseContactPopup">
    <div class="modal-dialog modal-lg">
        <div class="modal-content">
            <div class="modal-body">
                <div class="closed_icons">
                    <button type="button" class="close" data-dismiss="modal">&times;</button>
                </div>
                <div class="row">
                    <div class="col-sm-12">
                        <div class="contactPopupHeading">
                            <h2>企业咨询</h2>
                            <p *ngIf="formSection">请问您要咨询什么？</p>
                        </div>
                    </div>
                    <div class="inquiryTypeSection">
                        <ul class="nav nav-tabs" role="tablist" *ngIf="formSection">
                            <li class="nav-item">
                                <a class="nav-link" data-toggle="tab" href="#IndividualType" role="tab">
                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 50 50">
                                        <defs>
                                            <style>
                                                .cls-1 {
                                                    fill: none;
                                                    stroke: #783694;
                                                    stroke-linecap: round;
                                                    stroke-linejoin: round;
                                                    stroke-width: 2px;
                                                }
                                            </style>
                                        </defs>
                                        <title>TrinkaIcons-new</title>
                                        <g id="Individual">
                                            <path class="cls-1"
                                                d="M44.83,45.13V39.82a4.65,4.65,0,0,0-1.7-3.6,62.85,62.85,0,0,0-10.89-7V22.5a4.4,4.4,0,0,0,1.56-3.36V11.39A7.9,7.9,0,0,0,25.91,3.5H24.24a7.9,7.9,0,0,0-7.89,7.89v7.75a4.32,4.32,0,0,0,1.54,3.36h0v6.68A62.22,62.22,0,0,0,7,36.22a4.62,4.62,0,0,0-1.7,3.6v5.31" />
                                        </g>
                                    </svg>
                                    <div class="text-left">
                                        <h3>个人</h3>
                                        <span>（单用户）</span>
                                    </div>
                                </a>
                            </li>
                            <li class="nav-item">
                                <a class="nav-link" data-toggle="tab" href="#OrganizationType" role="tab">
                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 50 50">
                                        <defs>
                                            <style>
                                                .cls-1 {
                                                    fill: none;
                                                    stroke: #783694;
                                                    stroke-linecap: round;
                                                    stroke-linejoin: round;
                                                    stroke-width: 2px;
                                                }
                                            </style>
                                        </defs>
                                        <title>TrinkaIcons-new</title>
                                        <g id="Organization">
                                            <path class="cls-1"
                                                d="M42.87,45.13V40.06a4.45,4.45,0,0,0-1.62-3.44,60,60,0,0,0-10.41-6.72V23.51a4.2,4.2,0,0,0,1.49-3.21V12.89a7.55,7.55,0,0,0-7.54-7.54H23.19a7.55,7.55,0,0,0-7.54,7.54V20.3a4.13,4.13,0,0,0,1.47,3.21h0v6.38A59.44,59.44,0,0,0,6.71,36.62a4.42,4.42,0,0,0-1.62,3.44v5.07" />
                                            <path class="cls-1"
                                                d="M14.34,30.75a24.56,24.56,0,0,0-3.32-2V26.18a1.66,1.66,0,0,0,.59-1.27V22a3,3,0,0,0-3-3H8a3,3,0,0,0-3,3v2.93a1.63,1.63,0,0,0,.58,1.27h0v2.53a23.54,23.54,0,0,0-4.12,2.66,1.75,1.75,0,0,0-.64,1.36v2" />
                                            <path class="cls-1"
                                                d="M34.29,30.75a24.56,24.56,0,0,1,3.32-2V26.18A1.66,1.66,0,0,1,37,24.91V22a3,3,0,0,1,3-3h.63a3,3,0,0,1,3,3v2.93A1.63,1.63,0,0,1,43,26.18h0v2.53a23.54,23.54,0,0,1,4.12,2.66,1.75,1.75,0,0,1,.64,1.36v2" />
                                        </g>
                                    </svg>
                                    <div class="text-left">
                                        <h3>组织</h3>
                                        <span>（多用户）</span>
                                    </div>
                                </a>
                            </li>
                        </ul>
                        <div class="tab-content">
                            <div class="tab-pane" id="IndividualType" role="tabpanel" *ngIf="formSection">
                                <div class="IndividualTypeSection">
                                    <p>Trinka对于个人用户是免费的，<br />您只需注册您的电子邮件地址即可。</p>
                                    <a href="https://cloud.trinka.ai/signup?_rg=CN" target="_blank">免费注册</a>
                                </div>
                            </div>
                            <div class="tab-pane" id="OrganizationType" role="tabpanel" *ngIf="formSection">
                                <div class="row">
                                    <div class="col-md-12">
                                        <div class="contact_us_form">
                                            <form [formGroup]="contactForm" (ngSubmit)="sendContactUsForm()">
                                                <h2>请在下面提出您的要求，我们的团队将及时回复。</h2>
                                                <div class="row">
                                                    <div class="col-md-6 rightPaddingRemove">
                                                        <div class="textbox_content form-group"
                                                            [ngClass]="(!contactForm.get('NatureBusinessType').valid && contactForm.get('NatureBusinessType').dirty) || (contactForm.get('NatureBusinessType').touched && contactForm.get('NatureBusinessType').pristine) ? 'TextFiledError' : '' ">
                                                            <mat-form-field appearance="outline">
                                                                <mat-label>业务性质*</mat-label>
                                                                <input matInput placeholder=""
                                                                    formControlName="NatureBusinessType"
                                                                    class="form-control">
                                                            </mat-form-field>
                                                        </div>
                                                    </div>
                                                    <div class="col-md-6 leftPaddingRemove">
                                                        <div class="textbox_content form-group"
                                                            [ngClass]="(!contactForm.get('contactFormSubjects').valid && contactForm.get('contactFormSubjects').dirty) || (contactForm.get('contactFormSubjects').touched && contactForm.get('contactFormSubjects').pristine) ? 'TextFiledError' : '' ">
                                                            <mat-form-field appearance="outline">
                                                                <mat-label>单位名称*</mat-label>
                                                                <input matInput placeholder=""
                                                                    formControlName="contactFormSubjects"
                                                                    class="form-control">
                                                            </mat-form-field>
                                                        </div>
                                                    </div>
                                                    <!-- <div class="col-md-12">
                                                        <div class="textbox_content form-group textareaBox"
                                                            [ngClass]="(!contactForm.get('contactFormMessage').valid && contactForm.get('contactFormMessage').dirty) || (contactForm.get('contactFormMessage').touched && contactForm.get('contactFormMessage').pristine) ? 'TextFiledError' : '' ">
                                                            <mat-form-field appearance="outline">
                                                                <mat-label>请告诉我们您的要求..*</mat-label>
                                                                <textarea
                                                                    title="例如。大约的用户数，每个用户的每月处理字数，所需的自定义设置等。"
                                                                    matInput formControlName="contactFormMessage"
                                                                    placeholder="" class="form-control"></textarea>
                                                            </mat-form-field>
                                                        </div>
                                                    </div> -->
                                                    <div class="col-md-12">
                                                        <div class="textbox_content form-group textareaBox"
                                                            [ngClass]="(!contactForm.get('contactFormMessage').valid && contactForm.get('contactFormMessage').dirty) || (contactForm.get('contactFormMessage').touched && contactForm.get('contactFormMessage').pristine) ? 'TextFiledError' : '' ">
                                                            <label for="">请告诉我们您的要求..*</label>
                                                            <textarea formControlName="contactFormMessage"
                                                                class="form-control"
                                                                placeholder="例如。大约的用户数，每个用户的每月处理字数，所需的自定义设置等。"></textarea>
                                                        </div>
                                                    </div>
                                                    <div class="col-md-6 rightPaddingRemove">
                                                        <div class="textbox_content form-group"
                                                            [ngClass]="(!contactForm.get('contactFormName').valid && contactForm.get('contactFormName').dirty) || (contactForm.get('contactFormName').touched && contactForm.get('contactFormName').pristine) ? 'TextFiledError' : '' ">
                                                            <mat-form-field appearance="outline">
                                                                <mat-label>您的姓名 *</mat-label>
                                                                <input matInput placeholder=""
                                                                    formControlName="contactFormName"
                                                                    class="form-control">
                                                            </mat-form-field>
                                                        </div>
                                                    </div>
                                                    <div class="col-md-6 leftPaddingRemove">
                                                        <div class="textbox_content form-group"
                                                            [ngClass]="(!contactForm.get('DesignationTypes').valid && contactForm.get('DesignationTypes').dirty) || (contactForm.get('DesignationTypes').touched && contactForm.get('DesignationTypes').pristine) ? 'TextFiledError' : '' ">
                                                            <mat-form-field appearance="outline">
                                                                <mat-label>指定*</mat-label>
                                                                <input matInput placeholder=""
                                                                    formControlName="DesignationTypes"
                                                                    class="form-control">
                                                            </mat-form-field>
                                                        </div>
                                                    </div>
                                                    <div class="col-md-6 rightPaddingRemove">
                                                        <div class="textbox_content form-group"
                                                            [ngClass]="(!contactForm.get('contactFormEmail').valid && contactForm.get('contactFormEmail').dirty) || (contactForm.get('contactFormEmail').touched && contactForm.get('contactFormEmail').pristine) ? 'TextFiledError' : '' ">
                                                            <mat-form-field appearance="outline">
                                                                <mat-label>电子邮件*</mat-label>
                                                                <input matInput placeholder=""
                                                                    formControlName="contactFormEmail"
                                                                    class="form-control">
                                                            </mat-form-field>
                                                        </div>
                                                    </div>
                                                    <div class="col-md-6 leftPaddingRemove">
                                                        <div class="textbox_content form-group"
                                                            [ngClass]="(!contactForm.get('contactphoneNo').valid && contactForm.get('contactphoneNo').dirty) || (contactForm.get('contactphoneNo').touched && contactForm.get('contactphoneNo').pristine) ? 'TextFiledError' : '' ">
                                                            <mat-form-field appearance="outline">
                                                                <mat-label>联络电话*（包括国际代码）</mat-label>
                                                                <input type="number" matInput placeholder=""
                                                                    formControlName="contactphoneNo"
                                                                    class="form-control">
                                                            </mat-form-field>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div class="form-group text-center">
                                                    <button type="submit" [disabled]="isSubmitting">送出</button>
                                                </div>
                                            </form>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="thank_section contact_us_form" *ngIf="thankSection" style="padding: 30px 0px 0 0;">
                                <div class="form-group">
                                    <h2>感谢您！</h2>
                                    <p>我们会尽快和您联络。</p>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>